// Theme presets
export const THEMES = {
  classic: {
    name: 'Classic Red',
    emoji: '🔴',
    vars: {
      '--color-primary': '#c0392b',
      '--color-primary-dark': '#8b0000',
      '--color-accent': '#f0b429',
      '--color-bg': '#0a1628',
      '--color-surface': '#132040',
      '--color-surface2': '#0d1b36',
      '--color-border': 'rgba(255,255,255,0.09)',
      '--color-text': '#e9ecef',
      '--color-muted': '#adb5bd',
      '--color-dim': '#6c757d',
    }
  },
  midnight: {
    name: 'Midnight Blue',
    emoji: '🌌',
    vars: {
      '--color-primary': '#2980b9',
      '--color-primary-dark': '#1a5276',
      '--color-accent': '#3ce0f0',
      '--color-bg': '#060d1a',
      '--color-surface': '#0c1929',
      '--color-surface2': '#091422',
      '--color-border': 'rgba(41,128,185,0.15)',
      '--color-text': '#e9ecef',
      '--color-muted': '#8fb4d4',
      '--color-dim': '#5b7fa3',
    }
  },
  forest: {
    name: 'Forest Green',
    emoji: '🌲',
    vars: {
      '--color-primary': '#27ae60',
      '--color-primary-dark': '#145a32',
      '--color-accent': '#f0b429',
      '--color-bg': '#060f0a',
      '--color-surface': '#0c1f14',
      '--color-surface2': '#091910',
      '--color-border': 'rgba(39,174,96,0.15)',
      '--color-text': '#e9ecef',
      '--color-muted': '#8fcba0',
      '--color-dim': '#5a9b6b',
    }
  },
  purple: {
    name: 'Royal Purple',
    emoji: '💜',
    vars: {
      '--color-primary': '#8e44ad',
      '--color-primary-dark': '#5b2c6f',
      '--color-accent': '#f0b429',
      '--color-bg': '#0a060f',
      '--color-surface': '#1a0d26',
      '--color-surface2': '#14091e',
      '--color-border': 'rgba(142,68,173,0.2)',
      '--color-text': '#e9ecef',
      '--color-muted': '#b78fd4',
      '--color-dim': '#8b5eb0',
    }
  },
  gold: {
    name: 'Gold & Dark',
    emoji: '⭐',
    vars: {
      '--color-primary': '#d4a017',
      '--color-primary-dark': '#9a7312',
      '--color-accent': '#f0b429',
      '--color-bg': '#0a0800',
      '--color-surface': '#1a1400',
      '--color-surface2': '#120e00',
      '--color-border': 'rgba(212,160,23,0.18)',
      '--color-text': '#f5e6c8',
      '--color-muted': '#c9a96e',
      '--color-dim': '#8a7040',
    }
  },
  light: {
    name: 'Light Mode',
    emoji: '☀️',
    vars: {
      '--color-primary': '#c0392b',
      '--color-primary-dark': '#8b0000',
      '--color-accent': '#d4a017',
      '--color-bg': '#f0f2f5',
      '--color-surface': '#ffffff',
      '--color-surface2': '#e8ecf0',
      '--color-border': 'rgba(0,0,0,0.1)',
      '--color-text': '#1a1a2e',
      '--color-muted': '#495057',
      '--color-dim': '#868e96',
    }
  },
};

export function applyTheme(preset, customOverrides = {}) {
  const theme = THEMES[preset] || THEMES.classic;
  const vars = { ...theme.vars, ...customOverrides };
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
  // Also set raw values for components that use them directly
  root.style.setProperty('--theme-preset', preset);
}

export function initTheme(settings) {
  const preset = settings?.theme_preset || 'classic';
  const overrides = {};
  if (settings?.theme_primary)  overrides['--color-primary']  = settings.theme_primary;
  if (settings?.theme_accent)   overrides['--color-accent']   = settings.theme_accent;
  if (settings?.theme_bg)       overrides['--color-bg']       = settings.theme_bg;
  if (settings?.theme_surface)  overrides['--color-surface']  = settings.theme_surface;
  applyTheme(preset, overrides);
}
